import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Star } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner';
import * as reviewsApi from '../../api/reviews.api';
import { errorMessage } from '../../api/client';

function LeaveReview() {
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const existing = await reviewsApi.reviewForBooking(bookingId);
        if (!cancelled && existing) { setRating(existing.rating); setComment(existing.comment || ''); }
      } catch (_) { /* nothing */ }
      finally { if (!cancelled) setLoading(false); }
    }
    load();
    return () => { cancelled = true; };
  }, [bookingId]);

  async function submit(e) {
    e.preventDefault();
    if (!rating) { toast.error('Please pick a rating.'); return; }
    setBusy(true);
    try {
      await reviewsApi.submitReview(bookingId, rating, comment);
      toast.success('Thanks for your review.');
      navigate(`/orders/${bookingId}`);
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  }

  if (loading) return <LoadingSpinner />;
  return (
    <>
      <PageHeader title="Leave a review" subtitle="Help other patients pick the right clinic." />
      <form onSubmit={submit} className="card" style={{ maxWidth: 560 }}>
        <div className="field">
          <label>Your rating</label>
          <div className="row" style={{ gap: 4 }}>
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n} type="button"
                onClick={() => setRating(n)}
                onMouseEnter={() => setHover(n)}
                onMouseLeave={() => setHover(0)}
                style={{ background: 'none', border: 0, cursor: 'pointer', padding: 4 }}
              >
                <Star size={28} fill={(hover || rating) >= n ? '#f59e0b' : 'none'} stroke="#f59e0b" />
              </button>
            ))}
          </div>
        </div>
        <div className="field">
          <label>Comments (optional)</label>
          <textarea className="input" rows="4" value={comment} onChange={(e) => setComment(e.target.value)} maxLength={2000} />
        </div>
        <button type="submit" className="btn btn-primary" disabled={busy}>Save review</button>
      </form>
    </>
  );
}

export default LeaveReview;
